if (!window.QBPAttributes) {
  window.QBPAttributes = (function() {
    function cleanValue(value) {
      if (value === null || value === undefined) {
        return '';
      }
      if (Array.isArray(value) && value.length > 0) {
        return cleanValue(value[0]);
      }
      if (typeof value === 'object') {
        if (value.value !== undefined) {
          return cleanValue(value.value);
        }
        return JSON.stringify(value);
      }
      return String(value);
    }

    function formatDisplayName(fieldName) {
      return fieldName
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    }

    function init(variantsData, fieldList, productId) {
      const tbody = document.getElementById('qbp-attributes-tbody-' + productId);
      const qbpContainer = document.querySelector('.qbp-attributes[data-product-id="' + productId + '"]');
      const legalContainer = document.querySelector('.qbp-legal-info[data-product-id="' + productId + '"]');
      const skuElement = document.getElementById('qbp-sku-' + productId);
      const prop65Element = document.getElementById('qbp-prop65-' + productId);
      const ageWarningElement = document.getElementById('qbp-age-warning-' + productId);
      const chokingWarningElement = document.getElementById('qbp-choking-warning-' + productId);

      if (!tbody || !qbpContainer) return;

      const variantAttributesMap = {};
      const variantSkuMap = {};
      const variantLegalMap = {};
      variantsData.forEach(variant => {
        variantSkuMap[variant.id] = variant.sku || '';
        variantLegalMap[variant.id] = {
          prop65_text: variant.prop65_text || '',
          choking_warning: variant.choking_warning || '',
          age_warning: variant.age_warning || ''
        };
        const processedAttrs = {};
        fieldList.forEach(fieldName => {
          const trimmedField = fieldName.trim();
          if (trimmedField && variant.attributes[trimmedField]) {
            const rawValue = variant.attributes[trimmedField];
            const cleanedValue = cleanValue(rawValue);
            if (cleanedValue) {
              processedAttrs[trimmedField] = {
                display_name: formatDisplayName(trimmedField),
                value: cleanedValue
              };
            }
          }
        });
        variantAttributesMap[variant.id] = processedAttrs;
      });

      window.updateQBPAttributes = function(variantId) {
        const variantAttrs = variantAttributesMap[variantId];
        const variantLegal = variantLegalMap[variantId];
        if (!tbody) return;

        if (skuElement && variantSkuMap[variantId] !== undefined) {
          skuElement.textContent = variantSkuMap[variantId];
        }

        if (variantLegal) {
          if (prop65Element) {
            prop65Element.textContent = variantLegal.prop65_text;
            prop65Element.closest('.qbp-legal-item').style.display = variantLegal.prop65_text ? '' : 'none';
          }
          if (ageWarningElement) {
            ageWarningElement.textContent = variantLegal.age_warning;
            ageWarningElement.closest('.qbp-legal-item').style.display = variantLegal.age_warning ? '' : 'none';
          }
          if (chokingWarningElement) {
            chokingWarningElement.textContent = variantLegal.choking_warning;
            chokingWarningElement.closest('.qbp-legal-item').style.display = variantLegal.choking_warning ? '' : 'none';
          }
          if (legalContainer) {
            const hasAnyLegal = variantLegal.prop65_text || variantLegal.choking_warning || variantLegal.age_warning;
            legalContainer.style.display = hasAnyLegal ? '' : 'none';
          }
        }

        tbody.innerHTML = '';

        if (variantAttrs && Object.keys(variantAttrs).length > 0) {
          fieldList.forEach(fieldName => {
            const trimmedField = fieldName.trim();
            if (trimmedField && variantAttrs[trimmedField]) {
              const attr = variantAttrs[trimmedField];
              const row = document.createElement('tr');
              row.innerHTML = `
                <td>${attr.display_name}:</td>
                <td>${attr.value}</td>
              `;
              tbody.appendChild(row);
            }
          });
        }

        if (qbpContainer) {
          if (tbody.children.length === 0) {
            qbpContainer.style.display = 'none';
          } else {
            qbpContainer.style.display = '';
          }
        }
      };

      return variantAttributesMap;
    }

    return {
      init: init
    };
  })();
}
